import { render } from "./MsbBondCard.vue?vue&type=template&id=661b9bbf"
import script from "./MsbBondCard.vue?vue&type=script&lang=js"
export * from "./MsbBondCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__